module.exports = __webpack_public_path__ + "img/entry3.e8516d1b.jpg";